export enum uxSurveyActionTypes {
  UPDATE_SURVEY_EAMIL = 'update_survey_email',
  UPDATE_SURVEY = 'update_survey',
  UPDATE_FETCHING_SURVEY = 'update_request_survey',
  UPDATE_ANSWERED_SURVEY = 'update_answered_survey',
  UPDATE_SURVEY_CHOICE = 'update_survey_choice',
  UPDATE_SURVEY_FEEDBACK_CHOICE = 'update_survey_feedback_choice',
}
